import Mysql from '@/utils/mysqlRequest'

// 创建表
function createTable(params) {
  return Mysql({
    url: '/mysql/create_table',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }

  })
}

// 查询表结构
function selectTable(params) {
  return Mysql({
    url: '/mysql/show_tab',
    method: 'get',
    params
  })
}

// 插入数据
function insertIntoValue(obj) {
  const params = {
    id: obj.id,
    userName: obj.userName,
    userId: obj.userId,
    modeType: obj.modeType,
    input: obj.input,
    img1: obj.img1,
    img2: obj.img2,
    img3: obj.img3,
    img4: obj.img4,
    uploadImage: obj.uploadImage,
    uploadMask: obj.uploadMask,
    referenceImage: obj.referenceImage,
    steps: obj.steps,
    guidance: obj.guidance,
    weight: obj.weight,
    cfg: obj.cfg,
    realResolutionWidth: obj.realResolutionWidth,
    realResolutionHeight: obj.realResolutionHeight,
    resolutionMatchWidth: obj.resolutionMatchWidth,
    resolutionMatchHeight: obj.resolutionMatchHeight,
    loraName: obj.loraName,
    galleryName: obj.galleryName,
    currentTime: obj.currentTime,
    taskLogId: obj.taskLogId
  }
  return Mysql({
    url: '/mysql/write',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }

  })
}

// 修改数据
function modifyTableValue(obj) {
  const params = {
    id: obj.id,
    userName: obj.userName,
    userId: obj.userId,
    modeType: obj.modeType,
    input: obj.input,
    img1: obj.img1,
    img2: obj.img2,
    img3: obj.img3,
    img4: obj.img4,
    uploadImage: obj.uploadImage,
    uploadMask: obj.uploadMask,
    referenceImage: obj.referenceImage,
    steps: obj.steps,
    guidance: obj.guidance,
    weight: obj.weight,
    cfg: obj.cfg,
    realResolutionWidth: obj.realResolutionWidth,
    realResolutionHeight: obj.realResolutionHeight,
    resolutionMatchWidth: obj.resolutionMatchWidth,
    resolutionMatchHeight: obj.resolutionMatchHeight,
    loraName: obj.loraName,
    galleryName: obj.galleryName,
    currentTime: obj.currentTime,
    taskLogId: obj.taskLogId
  }
  return Mysql({
    url: '/mysql/modify',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }

  })
}

// 删除数据
function deleteTableValue(obj) {
  const params = {
    userId: obj.userId,
    id: obj.id
  }
  return Mysql({
    url: '/mysql/delete',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }

  })
}

// 查询指定数据[重新编辑]
function tableRowShow(obj) {
  const params = {
    userId: obj.userId,
    id: obj.id
  }
  return Mysql({
    url: '/mysql/search',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }

  })
}

// 查看主页封面表
function homePageCover() {
  return Mysql({
    url: '/template/show_tab',
    method: 'get'
  })
}
// 查看主页封面模型数据
function homePageTemplate() {
  return Mysql({
    url: '/template_list/show_tab',
    method: 'get'
  })
}

// 查看模型库数据
function modelList() {
  return Mysql({
    url: '/model_list/show_tab',
    method: 'get'
  })
}

// 创建收藏列表
function createFavorite(params) {
  return Mysql({
    url: '/favorite/create_table',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 查看收藏列表
function showFavorite(params) {
  return Mysql({
    url: '/favorite/show_tab',
    method: 'get',
    params
  })
}

// 添加收藏数据
function saveFavorite(params) {
  return Mysql({
    url: '/favorite/write',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 删除收藏数据
function deleteFavorite(params) {
  return Mysql({
    url: '/favorite/delete',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export {
  createTable, selectTable, insertIntoValue, modifyTableValue, deleteTableValue, tableRowShow,
  homePageCover, homePageTemplate, modelList, createFavorite, showFavorite, saveFavorite, deleteFavorite
}
